export enum PracticeDataUpdateAction {
    UPDATE_PRACTICE_DATA = 'UPDATE_PRACTICE_DATA',
    RESET_EDITABLE = 'RESET_EDITABLE',
    NO_SAVE = 'NO_SAVE'
  }
export  interface Drill {
  endTs: number;
  state: string;
  startTs: number;
  drillType: string;
  drillId?: number;
  periodType?: string;
  roofType?: string;
  session_id: string | number;
  }
  export interface HomeAwayTeam {
    nick: string;
  teamId: string;
  totalWins: number;
  totalLoss: number;
  totalTies: number;
  pointTotal: number;
  data: {
    color: {text: string};
    teamId: string;
    league: string;
    division: string;
    teamNick: string;
    teamAbbrName: string;
  };
  }
  export interface PracticeData {
    type: string;
  league: string;
  drills: Drill[];

    gameId?: string;
  datasetRefId?: string;
  startTime?: number;
  endTime?: number;
  homeTeam?: HomeAwayTeam;
  visitorTeam?: HomeAwayTeam;

    _id?: string;
  description?: string;
  intensity?: string;
  name?: string;
  profileName?: string;
  rooftype?: string;
  siteId?: string;
  siteName?: string;
  start?: number;
  teamId?: string;
  season?: string;
  __v?: number;
  currentDrill?: string;
  currentDrillIndex?: number;
  dsUpdateTimeStampChange?: boolean;
  isStarted?: boolean;
  lastDrillIndex?: number;
  lastDrillStartTime?: number;
  stepIndex?: number;
  totalElapsedTime?: number;
  dataset_id?: string;
  dataset_ref_id?: string;
  end?: number;
  endScheduleTs?: number;

}

export interface PracticeDataUpdateState {
  practiceDataUpdate: PracticeData;
  editableFlag: boolean;
  noSave: boolean;
}

export interface UpdatePracticeDataAction {
  type: PracticeDataUpdateAction.UPDATE_PRACTICE_DATA;
  practiceDataUpdate: PracticeData;
}
export interface ResetEditableAction {
  type: PracticeDataUpdateAction.RESET_EDITABLE;
  flag: boolean;
}

export interface NoSaveAction {
  type: PracticeDataUpdateAction.NO_SAVE;
  save: boolean;
}

export type PracticeDataUpdateActions = | UpdatePracticeDataAction | ResetEditableAction | NoSaveAction;
